module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', _vm._l((_vm.docs), function(item) {
    return _c('div', {
      staticClass: "mar"
    }, [_c('h3', [_vm._v(_vm._s(item.h3))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p1))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p2))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p3))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p4))])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "id": "about"
    }
  }, [_vm._v("ofo 共享单车首创“单车共享”模式"), _c('br'), _vm._v("是全球第一个无桩共享单车平台")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-404c2ca5"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutContent.vue
// module id = 20
// module chunks = 0